import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { X } from "lucide-react";

const ACCENT = "#FF3B30";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen grain bg-[#050505] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg w-full border-2 border-zinc-700 bg-black p-10 md:p-16 text-center"
      >
        <div className="flex justify-center mb-8 text-zinc-100">
          <X size={40} style={{ color: ACCENT }} />
        </div>
        <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-5xl text-zinc-50">
          Checkout Cancelled
        </h1>
        <p className="font-mono-b text-sm font-light text-zinc-400 mt-6 leading-relaxed">
          No charge was made. Whenever you're ready, the Basic Marketing package is waiting.
        </p>
        <Link
          to="/#pricing"
          data-testid="retry-link"
          className="btn-brutal inline-block mt-10 font-mono-b text-sm uppercase tracking-[0.2em] px-8 py-4 text-white"
          style={{ backgroundColor: ACCENT }}
        >
          Try Again
        </Link>
      </motion.div>
    </div>
  );
}
